module.exports = ".w-130 {\n  width: 130px; }\n"